import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import React, { useContext } from "react";
import { mainTheme } from "themes/themes";
import { getCurrentPage } from "utils/helpers";
import { PageContext } from "utils/PageContext";

function App() {
  const { page } = useContext(PageContext);

  return (
    <ThemeProvider theme={mainTheme}>
      <CssBaseline>
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            left: 0,
            top: 0,
            height: "100%",
            maxHeight: "100%",
            width: "100vw",
            overflowX: "hidden",
          }}
        >
          {getCurrentPage(page)}
        </Box>
      </CssBaseline>
    </ThemeProvider>
  );
}

export default App;
